import React from 'react';
import { Fade } from '@oneaudi/aoa-shared-editorial-components';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';
import { VideoPlayer } from '../VideoPlayer/VideoPlayer';
import { setAssetParams } from '../../utils/setAssetParams';

export const ResponsiveMedia = ({
  imageEnabled,
  fadeEnabled,
  fade,
  image,
  video,
  height,
  width,
  theme,
  isTest,
}) => {
  if (fadeEnabled) {
    const { color, direction, height: fadeHeight, opacity } = fade;
    return (
      <Fade
        color={color}
        direction={direction}
        height={fadeHeight}
        opacity={opacity}
        theme={theme}
        overlay
        cover
      >
        {imageEnabled ? (
          <ResponsiveImage
            {...setAssetParams({ image, video }, isTest, 'image').image}
            height={height}
            width={width}
          />
        ) : (
          <VideoPlayer
            {...setAssetParams({ video, image }, isTest, 'video').video}
            height={height}
            width={width}
            theme={theme}
            isTest={isTest}
          />
        )}
      </Fade>
    );
  }

  return imageEnabled ? (
    <ResponsiveImage
      {...setAssetParams({ video, image }, isTest, 'image').image}
      height={height}
      width={width}
    />
  ) : (
    <VideoPlayer
      {...setAssetParams({ video, image }, isTest, 'video').video}
      height={height}
      width={width}
      theme={theme}
      isTest={isTest}
    />
  );
};
